import { render, staticRenderFns } from "./LoanStatusBadge.vue?vue&type=template&id=0fcf4343"
import script from "./LoanStatusBadge.vue?vue&type=script&lang=js"
export * from "./LoanStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./LoanStatusBadge.vue?vue&type=style&index=0&id=0fcf4343&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports